import { Injectable, Injector } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';
import { CommonAuthService } from 'common/auth/common-auth.service';
import { LoggerService } from 'common/logger/logger.service';

@Injectable({ providedIn: 'root' })
export class LogService {
  constructor(private _bcRestApi: BcRestApi, private _injector: Injector) { }

  public getLoggerInstance(category: string): LoggerService {
    const commonAuth = this._injector.get(CommonAuthService);
    return new LoggerService(this._bcRestApi, category, commonAuth);
  }
}
